module.exports = {
    rootPath: window.__pathutils.rootPath
}